<div class="card">
  <div class="card-header">
    <h2 class="mt-2">Básico da Metodologia Científica</h2>
    <p class="px-1">Aqui você vai ter uma introdução à Metodologia Científica! Dividimos o conteúdo em 20 módulos,
      com aulas curtas e exemplos. Caso você tenha alguma dúvida, deixe um comentário ou entre em contato com nosso Call
      Center.</p>
  </div>
  <div class="card-body">
    <div id="accordion">
      <div class="form-group" style="margin-bottom: 0;">
        <div class="row">
          <div>
            <div class="card" *ngFor="let module of modules; let i = index;">
              <div class="card-header">
                <div [id]="'moduleContent'+i" style="margin: -6px auto;">
                  <button class="btn btn-link collapsed" data-toggle="collapse" [attr.data-target]="'#module'+i"
                    aria-expanded="false" [attr.aria-controls]="'module'+i">
                    <label [for]="'module'+i">{{module.name}}</label>
                  </button>
                </div>
              </div>
              <div [id]="'module'+i" class="collapse" [attr.aria-labelledby]="'moduleContent'+i"
                data-parent="#accordion">
                <div class="card-body">
                  <div>
                    <h5>{{module.leftColumnTop}}</h5>
                    <p>{{module.rightColumnTop}}</p>
                  </div>
                  <div>
                    <p>{{module.leftColumnBottom}}</p>
                    <ul>
                      <li *ngFor="let lesson of module.lessons; let j = index;">
                        <span>{{lesson.title}}</span>
                        <div *ngIf="lesson.youtubeLink">
                          <iframe [src]="lesson.youtubeLink" title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="card">
              <div class="card-header">
                <div id="moduleOneContent" style="margin: -6px auto;">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#moduleOne" aria-expanded="false" aria-controls="moduleOne">
                    <label for="moduleOne">Módulo 1</label>
                  </button>
                </div>
              </div>
              <div id="moduleOne" class="collapse" aria-labelledby="moduleOneContent" data-parent="#accordion">
                <div class="card-body module-one">
                  <div>
                    <p>O que vamos aprender?</p>
                    <p>Aqui você vai ter uma introdução a Metodologia Científica de uma forma muito rápida e
                      respondendo vários simulados. Para isso, dividimos o conteúdo em 20 módulos e cada módulo com algumas aulas:
                    </p>
                  </div>
                  <div>
                    <p>Vamos começar!</p>
                    <ul>
                      <li>
                        <span>Introdução [aula 1]</span>
                        <div>
                          <iframe width="560" height="315" src="https://www.youtube.com/embed/jUjhPgKi7Ao" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      </li>
                      <li>
                        <span>Cronograma - Ciclo 1 [aula 2]</span>
                        <div>
                          <iframe width="560" height="315" src="https://www.youtube.com/embed/My-qMR4Dduc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      </li>
                      <li>
                        <span>Dados Iniciais - Ciclo 1 [aula 3]</span>
                        <div>
                          <iframe width="560" height="315" src="https://www.youtube.com/embed/MDKa6do8fmY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <div id="moduleTwoContent" style="margin: -6px auto;">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#moduleTwo" aria-expanded="false" aria-controls="moduleTwo">
                    <label for="moduleTwo">Módulo 2</label>
                  </button>
                </div>
              </div>
              <div id="moduleTwo" class="collapse" aria-labelledby="moduleTwoContent" data-parent="#accordion">
                <div class="card-body module-one">
                  <div>
                    <p>O que vamos aprender?</p>
                    <p>Aqui você vai ter uma introdução a Metodologia Científica de uma forma muito rápida e
                      respondendo vários simulados. Para isso, dividimos o conteúdo em 20 módulos e cada módulo com algumas aulas:
                    </p>
                  </div>
                  <div>
                    <p>Vamos começar!</p>
                    <ul>
                      <li>
                        <span>Objetivos: geral e específicos - [aula 1]</span>
                        <div>
                          <iframe width="560" height="315" src="https://www.youtube.com/embed/1W7vn6HFf3s" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      </li>
                      <li>
                        <span>Justificativa - [aula 2]</span>
                        <div>
                          <iframe width="560" height="315" src="https://www.youtube.com/embed/GkHNKpllCRs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>